export default __webpack_public_path__ + "static/media/Land-transparent.080f3d9f.png";